// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","social":"Header_social__CqfLi","icons":"Header_icons__t0i1q"};